export default {
  login: 'Авторизоваться',
  logout: 'Выход',
  loginRequired: 'Необходимо авторизоваться',
  dateNotFilled: 'дата не заполнена',
  save: 'Сохранить',
  cancel: 'Отмена',
  savingError: 'Во время сохранения произошла ошибка: {error}.',
  savingSuccess: 'Данные сохранены!',
  addFile: 'Добавить файл',
  loading: 'Загрузка...',
  documentTip: `На фото не должно быть лишних объектов, для сканирования телефоном рекомендуем
   программу Microsoft Lens.`,
  ifErrorWhenUploading: {
    message:
      'Если возникают ошибки при загрузке документов, то выложи их в {0}. Желательно указать название документа в имени файла.',
    folder: 'папку',
  },
  privacyPolicy: 'Политика обработки персональных данных кандидатов',
};
